import { Component } from "@angular/core";

@Component({
    selector: "kt-graph-loader",
    templateUrl: './graph-loader.component.html',
    styleUrls: ['graph-loader.component.scss']
})
export class GraphLoaderComponent {

}